import { supabase } from '@/integrations/supabase/client';
import { Partner, PartnerMetrics, PartnerPayment, PartnerSummaryMetrics } from '@/types/partner';

export async function getPartnerMetrics(adminId: string): Promise<Partner[]> {
  const { data, error } = await supabase
    .rpc('get_partner_metrics', { p_admin_id: adminId });

  if (error) throw error;
  return data || [];
}

export async function getPartnerSummaryMetrics(adminId: string): Promise<PartnerSummaryMetrics> {
  const { data, error } = await supabase
    .rpc('get_partner_summary_metrics', { p_admin_id: adminId });

  if (error) throw error;
  return data || {
    total_partners: 0,
    active_partners: 0,
    total_earnings: 0,
    pending_payments: 0,
    total_referrals: 0,
    conversion_rate: 0
  };
}

export async function getSinglePartnerMetrics(
  adminId: string,
  partnerId: string
): Promise<PartnerMetrics> {
  const { data, error } = await supabase
    .rpc('get_single_partner_metrics', {
      p_admin_id: adminId,
      p_affiliate_id: partnerId
    });

  if (error) throw error;
  return data || {
    total_earnings: 0,
    pending_payment: 0,
    total_referrals: 0,
    active_referrals: 0,
    conversion_rate: 0,
    last_payment_date: null,
    last_referral_date: null,
    average_commission: 0
  };
}

export async function getPartnerPaymentHistory(
  adminId: string,
  partnerId?: string,
  startDate?: Date,
  endDate?: Date
): Promise<PartnerPayment[]> {
  const { data, error } = await supabase
    .rpc('get_partner_payment_history', {
      p_admin_id: adminId,
      p_affiliate_id: partnerId,
      p_start_date: startDate?.toISOString(),
      p_end_date: endDate?.toISOString()
    });

  if (error) throw error;
  return data || [];
}

export async function processPartnerPayment(
  adminId: string,
  partnerId: string,
  amount: number,
  paymentMethod: string = 'PayPal',
  notes?: string
): Promise<boolean> {
  const { data, error } = await supabase
    .rpc('process_partner_payment', {
      p_admin_id: adminId,
      p_affiliate_id: partnerId,
      p_amount: amount,
      p_payment_method: paymentMethod,
      p_notes: notes
    });

  if (error) throw error;
  return data || false;
}
